import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "PricingSelection" }
const _hoisted_2 = {
  key: 0,
  class: "SelectionDetailsWarningMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MultiSelect, {
      ref: "pricingProductsMultiSelect",
      class: "PricingProductsMultiSelect",
      label: "Pricing",
      placeholder: "Select a pricing product",
      searchable: true,
      groups: _ctx.referralPricingProductsAsOptionGroups,
      onUpdated: _ctx.setPricing
    }, null, 8 /* PROPS */, ["groups", "onUpdated"]),
    (!_ctx.didSelectedEntitiesHaveTheSamePricingOnToolLoad)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "lnr-warning SelectionWarningIcon" }, null, -1 /* CACHED */),
          _createElementVNode("span", null, " By default, no pricing product is selected here. The reason for this is that the selected organisations and studies do not have the same pricing product attached. ", -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true)
  ]))
}